export function validatePhoneNumber(value) {
  const phoneNumber = new RegExp(
    /^[\+]?[1]?[-\s\.]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
  );

  return value && !phoneNumber.test(value)
    ? "Please enter a 10 digit phone number"
    : "";
}
